import { useState, useEffect } from "react";
import {
  createIncident,
  sendIncident,
  updateIncident,
  deleteIncident,
  getIncidentDiagnoses,
} from "../../../api/incidents";
import { getRegions, getDistricts } from "../../../api/region";
import { useNavigate } from "react-router-dom";
import { getLang } from "../../../store/uiStore";
import "./InfectionForm.css";

export default function InfectionForm({
  initialData = null,
  isEdit = false,
  isReadonly = false,
}) {
  const [form, setForm] = useState({
    disease: "",
    diagnosis_type: "",
    patient_name: "",
    gender: "",
    birth_date: "",
    patient_age: "",
    phone: "",
    region: "",
    district: "",
    address: "",
    occupation_type: "",
    organization: "",
    position: "",
    illness_start_date: "",
    visit_date: "",
    diagnosis_date: "",
    infection_source: "",
    comment: "",
    notification_date: "",
  });

  const [incidentId, setIncidentId] = useState(initialData?.id || null);
  const [errors, setErrors] = useState({});
  const [regions, setRegions] = useState([]);
  const [districtsMap, setDistrictsMap] = useState({});
  const [diagnoses, setDiagnoses] = useState([]);
  const [diseaseQuery, setDiseaseQuery] = useState("");
  const [diagnosisDropdownOpen, setDiagnosisDropdownOpen] = useState(false);
  const [diseaseTouched, setDiseaseTouched] = useState(false);

  const navigate = useNavigate();
  const lang = getLang();

  const tr = {
    saved: lang === "ru" ? "Сохранено" : "Сабт шуд",
    sent: lang === "ru" ? "Отправлено" : "Фиристода шуд",
    updated: lang === "ru" ? "Обновлено" : "Навсозӣ шуд",
    deleted: lang === "ru" ? "Удалено" : "Нест карда шуд",

    title:
      lang === "ru"
        ? "Экстренное извещение"
        : "Хабарномаи фаврӣ",

    diseaseSection:
      lang === "ru"
        ? "Сведения о заболевании"
        : "Маълумот дар бораи беморӣ",

    patientSection:
      lang === "ru"
        ? "Данные пациента"
        : "Маълумоти бемор",

    addressSection:
      lang === "ru"
        ? "Контакты и адрес"
        : "Тамос ва суроға",

    workSection:
      lang === "ru"
        ? "Работа / учеба"
        : "Кор / таҳсил",

    datesSection:
      lang === "ru"
        ? "Хронология заболевания"
        : "Раванди беморӣ",

    sourceSection:
      lang === "ru"
        ? "Источник / фактор"
        : "Манбаъ / омил",

    extraSection:
      lang === "ru"
        ? "Дополнительные сведения"
        : "Маълумоти иловагӣ",

    notifySection:
      lang === "ru"
        ? "Дата заполнения"
        : "Санаи пуркунӣ",

    diagnosis:
      lang === "ru" ? "Диагноз" : "Ташхис",
    diagnosisSearchPlaceholder:
      lang === "ru"
        ? "Начните вводить название диагноза"
        : "Номи ташхисро ворид кунед",
    diagnosisNotSelected:
      lang === "ru"
        ? "Выберите диагноз из выпадающего списка"
        : "Ташхисро аз рӯйхати кушодашаванда интихоб кунед",

    diagnosisType:
      lang === "ru"
        ? "Тип диагноза"
        : "Навъи ташхис",

    preliminary:
      lang === "ru"
        ? "Предварительный"
        : "Пешакӣ",

    final:
      lang === "ru"
        ? "Окончательный"
        : "Ниҳоӣ",

    patientName:
      lang === "ru"
        ? "ФИО пациента"
        : "Ному насаби бемор",

    gender:
      lang === "ru"
        ? "Пол"
        : "Ҷинс",

    male:
      lang === "ru"
        ? "Мужской"
        : "Мард",

    female:
      lang === "ru"
        ? "Женский"
        : "Зан",

    birthDate:
      lang === "ru"
        ? "Дата рождения"
        : "Санаи таваллуд",

    age:
      lang === "ru"
        ? "Возраст"
        : "Синну сол",

    phone:
      lang === "ru"
        ? "Телефон"
        : "Телефон",

    region:
      lang === "ru"
        ? "Область"
        : "Вилоят",

    district:
      lang === "ru"
        ? "Район"
        : "Ноҳия",

    address:
      lang === "ru"
        ? "Адрес"
        : "Суроға",

    occupationType:
      lang === "ru"
        ? "Тип"
        : "Навъ",

    employed:
      lang === "ru"
        ? "Работает"
        : "Кор мекунад",

    student:
      lang === "ru"
        ? "Учится"
        : "Таҳсил мекунад",

    other:
      lang === "ru"
        ? "Другое"
        : "Дигар",

    organization:
      lang === "ru"
        ? "Организация / учреждение"
        : "Ташкилот / муассиса",

    position:
      lang === "ru"
        ? "Должность / класс"
        : "Вазифа / синф",

    illnessStart:
      lang === "ru"
        ? "Дата начала заболевания"
        : "Санаи оғози беморӣ",

    visitDate:
      lang === "ru"
        ? "Дата обращения"
        : "Санаи муроҷиат",

    diagnosisDate:
      lang === "ru"
        ? "Дата постановки диагноза"
        : "Санаи ташхис",

    source:
      lang === "ru"
        ? "Продукт / источник заражения"
        : "Маҳсулот / манбаи сироят",

    comment:
      lang === "ru"
        ? "Комментарий"
        : "Шарҳ",

    notifiedBy:
      lang === "ru"
        ? "Кем отправлено"
        : "Аз ҷониби кӣ фиристода шуд",

    notifiedTo:
      lang === "ru"
        ? "Кому передано"
        : "Ба кӣ фиристода шуд",

    notificationDate:
      lang === "ru"
        ? "Дата сообщения"
        : "Санаи хабар",

    save:
      lang === "ru"
        ? "Сохранить"
        : "Сабт кардан",

    send:
      lang === "ru"
        ? "Отправить"
        : "Фиристодан",

    update:
      lang === "ru"
        ? "Обновить"
        : "Навсозӣ",

    remove:
      lang === "ru"
        ? "Удалить"
        : "Нест кардан",
  };

  useEffect(() => {
    getRegions().then((res) => setRegions(res.data));
  }, []);

  useEffect(() => {
    getIncidentDiagnoses(lang)
      .then((res) => setDiagnoses(Array.isArray(res.data) ? res.data : []))
      .catch((error) => {
        console.error("Unable to load incident diagnoses", error);
        setDiagnoses([]);
      });
  }, [lang]);

  useEffect(() => {
    if (!initialData) return;

    const data = initialData.data || {};
    const savedDisease = data.disease || "";
    const matchedDiagnosis = diagnoses.find(
      (item) => item.value === savedDisease || item.tj === savedDisease || item.ru === savedDisease
    );

    setForm((prev) => ({
      ...prev,
      ...data,
      disease: matchedDiagnosis ? matchedDiagnosis.value : savedDisease,
    }));
    setDiseaseQuery(
      matchedDiagnosis ? matchedDiagnosis.label : savedDisease
    );
  }, [initialData, diagnoses]);

  useEffect(() => {
    if (form.region) {
      loadDistricts(form.region);
    }
  }, [form.region]);

  const loadDistricts = (regionId) => {
    if (!regionId) return;

    const id =
      typeof regionId === "object"
        ? regionId.id
        : regionId;

    getDistricts(id).then((res) => {
      setDistrictsMap((prev) => ({
        ...prev,
        [String(id)]: res.data,
      }));
    });
  };

  const getRegionId = (region) =>
    typeof region === "object" && region !== null
      ? region.id
      : region;

  const handleChange = (e) => {
    if (isReadonly) return;

    const { name, value } = e.target;

    setForm((prev) => {
      const updated = {
        ...prev,
        [name]: value,
      };

      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));

      if (name === "birth_date" && value) {
        const today = new Date();
        const birth = new Date(value);

        let age =
          today.getFullYear() - birth.getFullYear();

        const m =
          today.getMonth() - birth.getMonth();

        if (
          m < 0 ||
          (m === 0 &&
            today.getDate() < birth.getDate())
        ) {
          age--;
        }

        updated.patient_age = String(age);

        setErrors((prevErrors) => ({
          ...prevErrors,
          patient_age: "",
        }));
      }

      if (name === "region") {
        updated.district = "";
      }

      return updated;
    });
  };

  const filteredDiagnoses = diagnoses.filter((item) =>
    item.label.toLocaleLowerCase().includes(diseaseQuery.trim().toLocaleLowerCase())
  );

  const handleDiseaseQueryChange = (event) => {
    if (isReadonly) return;
    setDiseaseQuery(event.target.value);
    setDiseaseTouched(true);
    setDiagnosisDropdownOpen(true);
    setForm((prev) => ({ ...prev, disease: "" }));
    setErrors((prev) => ({ ...prev, disease: "" }));
  };

  const selectDiagnosis = (diagnosis) => {
    setForm((prev) => ({ ...prev, disease: diagnosis.value }));
    setDiseaseQuery(diagnosis.label);
    setDiseaseTouched(false);
    setDiagnosisDropdownOpen(false);
    setErrors((prev) => ({ ...prev, disease: "" }));
  };

  const validate = () => {
    const newErrors = {};

    if (diseaseTouched && diseaseQuery.trim() && !form.disease) {
      newErrors.disease = tr.diagnosisNotSelected;
    }

    if (!form.disease && !newErrors.disease) {
      newErrors.disease =
        lang === "ru"
          ? "Выберите диагноз из списка"
          : "Ташхисро аз рӯйхат интихоб кунед";
    }

    if (!form.patient_name) {
      newErrors.patient_name =
        lang === "ru"
          ? "Введите ФИО"
          : "Ному насабро ворид кунед";
    }

    if (!form.patient_age) {
      newErrors.patient_age =
        lang === "ru"
          ? "Введите возраст"
          : "Синну солро ворид кунед";
    }

    if (!form.region) {
      newErrors.region =
        lang === "ru"
          ? "Выберите область"
          : "Вилоятро интихоб кунед";
    }

    if (!form.district) {
      newErrors.district =
        lang === "ru"
          ? "Выберите район"
          : "Ноҳияро интихоб кунед";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const buildPayload = () => ({
    type: "infection",
    data: form,
  });

  const save = async () => {
    if (diseaseTouched && diseaseQuery.trim() && !form.disease) {
      setErrors((prev) => ({ ...prev, disease: tr.diagnosisNotSelected }));
      return;
    }

    const payload = buildPayload();

    if (incidentId) {
      await updateIncident(incidentId, payload);
    } else {
      const res = await createIncident(payload);
      setIncidentId(res.data.id);
      navigate(`/incidents/${res.data.id}`);
    }

    alert(tr.saved);
  };

  const send = async () => {
    if (!validate()) return;

    const payload = buildPayload();

    if (incidentId) {
      await updateIncident(incidentId, payload);
      await sendIncident(incidentId);
    } else {
      const res = await createIncident(payload);
      setIncidentId(res.data.id);
      await sendIncident(res.data.id);
    }

    alert(tr.sent);
  };

  const update = async () => {
    if (diseaseTouched && diseaseQuery.trim() && !form.disease) {
      setErrors((prev) => ({ ...prev, disease: tr.diagnosisNotSelected }));
      return;
    }

    await updateIncident(initialData.id, buildPayload());
    alert(tr.updated);
  };

  const remove = async () => {
    await deleteIncident(initialData.id);
    alert(tr.deleted);
    window.location.href = "/incidents";
  };

  return (
    <div className="nizom-infection-form" style={styles.container}>
      <h2>{tr.title}</h2>

      <div style={styles.section}>
        <h3>{tr.diseaseSection}</h3>

        <div style={styles.row}>
          <div style={styles.field}>
            <div style={{ position: "relative", width: "100%" }}>
              <input
                name="disease_search"
                placeholder={tr.diagnosisSearchPlaceholder}
                value={diseaseQuery}
                onChange={handleDiseaseQueryChange}
                onFocus={() => !isReadonly && setDiagnosisDropdownOpen(true)}
                onBlur={() => setTimeout(() => setDiagnosisDropdownOpen(false), 120)}
                autoComplete="off"
                disabled={isReadonly}
                aria-autocomplete="list"
                aria-expanded={!isReadonly && diagnosisDropdownOpen}
                style={styles.input}
              />

              {!isReadonly && diagnosisDropdownOpen && filteredDiagnoses.length > 0 && (
                <div className="nizom-diagnosis-options" role="listbox">
                  {filteredDiagnoses.map((diagnosis) => (
                    <button
                      type="button"
                      key={diagnosis.value}
                      className="nizom-diagnosis-option"
                      onMouseDown={(event) => event.preventDefault()}
                      onClick={() => selectDiagnosis(diagnosis)}
                      role="option"
                      aria-selected={form.disease === diagnosis.value}
                    >
                      {diagnosis.label}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {errors.disease && (
              <div style={styles.error}>
                {errors.disease}
              </div>
            )}
          </div>

          <div style={styles.field}>
            <select
              name="diagnosis_type"
              value={form.diagnosis_type}
              onChange={handleChange}
              disabled={isReadonly}
              style={styles.input}
            >
              <option value="">{tr.diagnosisType}</option>
              <option value="preliminary">{tr.preliminary}</option>
              <option value="final">{tr.final}</option>
            </select>
          </div>
        </div>
      </div>

      <div style={styles.section}>
        <h3>{tr.patientSection}</h3>

        <div style={styles.row}>
          <div style={styles.field}>
            <div style={styles.labelSpace}></div>
            <input
              name="patient_name"
              placeholder={tr.patientName}
              value={form.patient_name}
              onChange={handleChange}
              disabled={isReadonly}
              style={styles.input}
            />
            {errors.patient_name && (
              <div style={styles.error}>
                {errors.patient_name}
              </div>
            )}
          </div>

          <div style={styles.field}>
            <div style={styles.labelSpace}></div>
            <select
              name="gender"
              value={form.gender}
              onChange={handleChange}
              disabled={isReadonly}
              style={styles.input}
            >
              <option value="">{tr.gender}</option>
              <option value="male">{tr.male}</option>
              <option value="female">{tr.female}</option>
            </select>
          </div>

          <div style={styles.field}>
            <label style={styles.label}>{tr.birthDate}</label>
            <input
              type="date"
              name="birth_date"
              value={form.birth_date}
              onChange={handleChange}
              disabled={isReadonly}
              style={styles.input}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>{tr.age}</label>
            <input
              name="patient_age"
              value={form.patient_age}
              onChange={handleChange}
              disabled={isReadonly}
              style={styles.input}
            />
            {errors.patient_age && (
              <div style={styles.error}>
                {errors.patient_age}
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={styles.section}>
        <h3>{tr.addressSection}</h3>

        <div style={styles.field}>
          <input
            name="phone"
            placeholder={tr.phone}
            value={form.phone}
            onChange={handleChange}
            disabled={isReadonly}
            style={styles.input}
          />

          <div style={styles.field}>
            <select
              name="region"
              value={getRegionId(form.region) || ""}
              onChange={handleChange}
              disabled={isReadonly}
              style={styles.input}
            >
              <option value="">{tr.region}</option>
              {regions.map((r) => (
                <option key={r.id} value={r.id}>
                  {lang === "ru" ? r.name_ru : r.name_tj}
                </option>
              ))}
            </select>

            {errors.region && (
              <div style={styles.error}>{errors.region}</div>
            )}
          </div>

          <div style={styles.field}>
            <select
              name="district"
              value={form.district || ""}
              onChange={handleChange}
              disabled={isReadonly || !getRegionId(form.region)}
              style={styles.input}
            >
              <option value="">{tr.district}</option>
              {(districtsMap[String(getRegionId(form.region))] || []).map((d) => (
                <option key={d.id} value={d.id}>
                  {lang === "ru" ? d.name_ru : d.name_tj}
                </option>
              ))}
            </select>

            {errors.district && (
              <div style={styles.error}>{errors.district}</div>
            )}
          </div>
        </div>

        <input
          name="address"
          placeholder={tr.address}
          value={form.address}
          onChange={handleChange}
          disabled={isReadonly}
          style={styles.inputFull}
        />
      </div>

      <div style={styles.section}>
        <h3>{tr.workSection}</h3>

        <div style={styles.row}>
          <select
            name="occupation_type"
            value={form.occupation_type}
            onChange={handleChange}
            disabled={isReadonly}
            style={styles.input}
          >
            <option value="">{tr.occupationType}</option>
            <option value="employed">{tr.employed}</option>
            <option value="student">{tr.student}</option>
            <option value="other">{tr.other}</option>
          </select>

          <input
            name="organization"
            placeholder={tr.organization}
            value={form.organization}
            onChange={handleChange}
            disabled={isReadonly}
            style={styles.input}
          />

          <input
            name="position"
            placeholder={tr.position}
            value={form.position}
            onChange={handleChange}
            disabled={isReadonly}
            style={styles.input}
          />
        </div>
      </div>

      <div style={styles.section}>
        <h3>{tr.datesSection}</h3>

        <div style={styles.row}>
          <div style={{ flex: 1 }}>
            <label style={styles.label}>{tr.illnessStart}</label>
            <input
              type="date"
              name="illness_start_date"
              value={form.illness_start_date}
              onChange={handleChange}
              disabled={isReadonly}
              style={styles.input}
            />
          </div>

          <div style={{ flex: 1 }}>
            <label style={styles.label}>{tr.visitDate}</label>
            <input
              type="date"
              name="visit_date"
              value={form.visit_date}
              onChange={handleChange}
              disabled={isReadonly}
              style={styles.input}
            />
          </div>

          <div style={{ flex: 1 }}>
            <label style={styles.label}>{tr.diagnosisDate}</label>
            <input
              type="date"
              name="diagnosis_date"
              value={form.diagnosis_date}
              onChange={handleChange}
              disabled={isReadonly}
              style={styles.input}
            />
          </div>
        </div>
      </div>

      <div style={styles.section}>
        <h3>{tr.sourceSection}</h3>
        <input
          name="infection_source"
          placeholder={tr.source}
          value={form.infection_source}
          onChange={handleChange}
          disabled={isReadonly}
          style={styles.inputFull}
        />
      </div>

      <div style={styles.section}>
        <h3>{tr.extraSection}</h3>
        <textarea
          name="comment"
          placeholder={tr.comment}
          value={form.comment}
          onChange={handleChange}
          disabled={isReadonly}
          style={styles.textarea}
        />
      </div>

      <div style={styles.section}>
        <h3>{tr.notifySection}</h3>

        <div style={{ maxWidth: "320px" }}>
          <input
            type="date"
            name="notification_date"
            value={form.notification_date}
            onChange={handleChange}
            disabled={isReadonly}
            style={styles.input}
          />
        </div>
      </div>

      {!isReadonly && (
        <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
          {!isEdit && (
            <>
              <button onClick={save}>{tr.save}</button>
              <button onClick={send}>{tr.send}</button>
            </>
          )}

          {isEdit && (
            <>
              <button onClick={update}>{tr.update}</button>
              <button onClick={send}>{tr.send}</button>
              <button onClick={remove}>{tr.remove}</button>
            </>
          )}
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    width: "100%",
    padding: "20px",
  },

  section: {
    background: "#fff",
    padding: "20px",
    marginBottom: "20px",
    borderRadius: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  },

  row: {
    display: "flex",
    gap: "10px",
    marginBottom: "10px",
  },

  label: {
    display: "block",
    marginBottom: "6px",
    fontSize: "14px",
    color: "#374151",
    fontWeight: 500,
  },

  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },

  inputFull: {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },

  textarea: {
    width: "100%",
    minHeight: "80px",
    marginBottom: "10px",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },

  error: {
    color: "#dc2626",
    fontSize: "12px",
    marginTop: "4px",
    minHeight: "18px",
  },

  field: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
  },

  labelSpace: {
    height: "26px",
    display: "flex",
    alignItems: "center",
  },
};
